import React from 'react';
import LocalizedStrings from 'react-localization';
// eslint-disable-next-line
import agent from '../../agent';
import { connect } from 'react-redux';
import { DASHBOARD_SLIDER_PAGE_LOADED, DASHBOARD_SLIDER_PAGE_UNLOADED} from '../../constants/actionTypes';
import Dashboard from '../Dashboard/Dashboard'
import Loader from '../Dashboard/components/Loader/Loader'
import { toast } from 'react-toastify';
import Hammer from 'react-hammerjs'
import '../../../node_modules/slick-carousel/slick/slick.css'
import '../../../node_modules/slick-carousel/slick/slick-theme.css'

const mapStateToProps = state => ({
  ...state.dashboard,
  appName: state.common.appName,
  token: state.common.token,
  redirectTo: state.common.redirectTo,
  configurationId:state.common.configurationId
});

const mapDispatchToProps = dispatch => ({
  onLoad: (token, configurationId) =>
    dispatch({ type: DASHBOARD_SLIDER_PAGE_LOADED, token: token, payload: configurationId ? agent.View.getConfig(configurationId) : null}),
  onUnload: () =>
    dispatch({  type: DASHBOARD_SLIDER_PAGE_UNLOADED, token: window.localStorage.getItem('jwt') })
});


class DashboardSwitcher extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      "currentPage":0,
      "paused":false
    }

    this.strings = new LocalizedStrings({
     en:{
       dashboardPaused: 'Dashboard Paused',
       dashboardResumed: 'Dashboard Resumed',
     },
     de: {
       dashboardPaused: 'Daschboard angehaltet',
       dashboardResumed: 'Daschboard freigegeben',
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  tick() {
    if(this.state && !this.state.paused && this.props.config && this.props.config.result && this.props.config.data.pages && this.getPages().length > 1) {
      this.nextPage()
    }
  }

  nextPage() {
    const maxPageIndex = this.getPages().length -1;
    const currentPage = this.state.currentPage;
    var nextPage = currentPage;

    if(currentPage === maxPageIndex) {
      nextPage = 0;
    } else {
      nextPage = currentPage + 1;
    }

    this.setState({
      ...this.state,
      "currentPage":nextPage
    })
  }

  previousPage() {
    const maxPageIndex = this.getPages().length -1;
    const currentPage = this.state.currentPage;
    var nextPage = currentPage;

    if(currentPage === 0) {
      nextPage = maxPageIndex;
    } else {
      nextPage = currentPage - 1;
    }

    this.setState({
      ...this.state,
      "currentPage":nextPage
    })
  }

  toggleDashboardSwitcher() {
    const paused = this.state.paused ? false : true

    if(paused) {
      toast.error(this.strings.dashboardPaused, {
        hideProgressBar:true,
        autoClose:3000
      })
    } else {
      toast.success(this.strings.dashboardResumed,{
        hideProgressBar:true,
        autoClose:3000
      })
    }

    this.setState({
      ...this.state,
      paused:paused
    })
  }

  componentWillMount() {
    const token = this.props.token;
    const configurationId = this.props.configurationId;
    this.props.onLoad(token, configurationId);
  }

  componentDidMount() {
    this.startPageSwitchTimer()
  }

  startPageSwitchTimer() {
    const delayInSeconds = 60;
    this.interval = setInterval(this.tick.bind(this), 1000 * delayInSeconds);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.props.onUnload();
  }

  dashboardLayoutUpdated(pageInternalId, layout) {

    for(var i = 0; i < this.props.config.data.pages.length; i++) {
      if(this.props.config.data.pages[i].internalId === pageInternalId) {
        this.props.config.data.pages[i].layouts.lg = layout
        break;
      }
    }

  }

  getPage() {
    const page = this.getPages()[this.state.currentPage]

    switch (page.type) {
      case "Dashboard":
        return (<Dashboard
                  key={page.internalId}
                  config={page}
                  configurationId={this.props.configurationId}
                  layoutUpdated={this.dashboardLayoutUpdated.bind(this)}
                />)
      default:
        return null;
    }

  }

  getPages() {
    if(this.props.config.data.showAllLanguages) {
      return this.props.config.data.pages;
    } else {
      let language = this.strings.getLanguage();
      let filteredPages = this.props.config.data.pages.filter(page => page.language === language);

      // if we dont have a matching language return all
      if(filteredPages.length === 0 && this.props.config.data.pages.length > 0) {
        return this.props.config.data.pages;
      }

      return filteredPages;
    }
  }

  onKeyPressed(e) {
    if(e.key === "ArrowRight") {
      this.switchRight()
    } else if(e.key === "ArrowLeft") {
      this.switchLeft()
    } else if(e.keyCode === 32) {
      this.toggleDashboardSwitcher();
    }
  }

  switchLeft() {
    clearInterval(this.interval);
    this.previousPage();
    this.startPageSwitchTimer();
  }

  switchRight() {
    clearInterval(this.interval);
    this.nextPage();
    this.startPageSwitchTimer();
  }

  handleSwipe(ev) {
    if(ev.pointerType === "touch" && ev.type === "swipe") {
      if(ev.direction === 2 && ev.velocity < -1) {
        this.switchLeft()
      } else if(ev.direction === 4 && ev.velocity > 1) {
        this.switchRight()
      }
    }
  }

  render() {
    if(this.props.config && this.props.config.result) {
      const page = this.getPage();
      return (
        <Hammer onSwipe={this.handleSwipe.bind(this)} options={{direction:"DIRECTION_HORIZONTAL"}}>
          <div onKeyDown={(e) => this.onKeyPressed(e)} tabIndex={0}>
            {page}
          </div>
        </Hammer>
      );
    } else {
      return(
          <div style={{height:'100vh'}}>
            <div className="row loader-fullheight-row">
              <div className="col align-self-center">
                <Loader/>
              </div>
            </div>
          </div>
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSwitcher);



// WEBPACK FOOTER //
// ./src/components/DashboardSwitcher/DashboardSwitcher.js